import styled from "styled-components";
import { WhiteContainer, WrapperContainer } from "../../components";
import { DropdownInputWrapper } from "../../components/DropdownInput/styled";
import { PagesWrapper } from "../../components/PageSelector/styled";

export const DashboardHeader = styled(WrapperContainer)`
  width: 100%;
  margin-bottom: 24px;

  ${DropdownInputWrapper} {
    max-width: 300px;
    height: fit-content !important;
  }

  ${PagesWrapper} {
    margin-top: 0px;
    width: fit-content;
  }
`;

export const DashboardContainer = styled(WhiteContainer)`
  overflow: hidden;
`;